export enum PERMISSIONS {
  CAN_VIEW_ALL_ORGANIZATION_USERS = "can_view_all_organization_users",
  CAN_VIEW_ORGANIZATION_USER_BALANCE = "can_view_organization_user_balance",
  CAN_DOES_ALL_OPERATIONS = "can_does_all_operations",
  CAN_VIEW_ALL_USERS = "can_view_all_users",
  CAN_ISSUE_TICKET = "can_issue_ticket",
  CAN_VIEW_SOA_ITEMS = "can_view_soa_items",
  CAN_REGISTER_USER = "can_register_user",
  CAN_VIEW_ORGANIZATION_USER_NEWS = "can_view_organization_user_news",
  CAN_VIEW_SEARCH_BOOK = "can_view_search_book",
  CAN_SEARCH_FLIGHTS = "can_search_flights",
  CAN_BOOK_FLIGHTS = "can_book_flights",
  CAN_FETCH_PNR = "can_fetch_pnr",
  CAN_ISSUE_FLIGHT_TICKET = "can_issue_flight_ticket",
  CAN_DOWNLOAD_SOA = "can_download_soa",
  CAN_EMAIL_SOA = "can_email_SOA",
  CAN_REQUEST_CREDIT_LIMIT = "can_request_credit_limit",
  CAN_CREATE_CARD_PAYMENT = "can_create_card_payment",
  CAN_CREATE_ONEBILL_PAYMENT = "can_create_onebill_payment",
  CAN_VIEW_ALL_PAYMENTS = "can_view_all_payments",
  CAN_VIEW_SELF_MADE_PAYMENTS = "can_view_self_made_payments",
  CAN_VIEW_ALL_FLIGHT_BOOKINGS = "can_view_all_flight_bookings",
  CAN_VIEW_SELF_MAKE_FLIGHT_BOOKINGS = "can_view_self_make_flight_bookings",
  CAN_VIEW_ORGANIZATION_USER_PRICING = "can_view_organization_user_pricing",
  CAN_SEARCH_HOTEL = "can_search_hotel",
  CAN_BOOK_HOTEL = "can_book_hotel",
  CAN_ISSUE_HOTEL = "can_issue_hotel",
  CAN_VIEW_ALL_BOOKINGS_OF_HOTEL = "can_view_all_bookings_of_hotel",
  CAN_VIEW_ONLY_SELF_MADE_BOOKINGS_OF_HOTEL = "can_view_only_self_made_bookings_of_hotel",
  CAN_BOOK_TOUR = "can_book_tour",
  CAN_VIEW_ALL_BOOKINGS_OF_TOUR = "can_view_all_bookings_of_tour",
  CAN_VIEW_SELF_MADE_BOOKING_OF_TOUR = "can_view_self_made_booking_of_tour",
  CAN_BOOK_FIT = "can_book_FIT",
  CAN_VIEW_ALL_BOOKINGS_OF_FIT = "can_view_all_bookings_of_FIT",
  CAN_VIEW_ONLY_SELF_MADE_BOOKING_OF_FIT = "can_view_only_self_made_booking_of_FIT",
  CAN_CHANGE_ORGANIZATION_PREFERENCES = "can_change_organization_preferences",
  CAN_CHANGE_EMPLOYEE_PERMISSIONS = "can_change_employee_permissions",
  CAN_LOGIN = "can_login",
  CAN_CREATE_PAYMENT = "can_create_payment",
  CAN_VIEW_SELF_MADE_FLIGHT_BOOKINGS = "can_view_self_made_flight_bookings",
  CAN_VIEW_ORGANIZATION = "can_view_organization",
  CAN_VIEW_ORGANIZATION_PREFERENCES = "can_view_organization_preferences",
  CAN_VIEW_ORGANIZATION_USERS = "can_view_organization_users",
  CAN_MANAGE_ORGANIZATION_SELF_PREFERENCES = "can_manage_organization_self_preferences",
  CAN_MANAGE_ORGANIZATION_USERS = "can_manage_organization_users",
  CAN_REFUND_FLIGHT_TICKET = "can_refund_flight_ticket",
  CAN_REFUND_SELF_FLIGHT_TICKET = "can_refund_self_flight_ticket",
  CAN_CHANGE_USER_PASSWORD = "can_change_user_password",
  CAN_VIEW_CREDIT_LIMIT = "can_view_credit_limit",
  CAN_VIEW_FIT = "can_view_fit",
  CAN_VIEW_GROUP_TOURS = "can_view_group_tours",
  CAN_VIEW_GROUP_FLIGHTS = "can_view_group_flights",
  CAN_VIEW_ALL_APPROVAL_WORKFLOWS = "can_view_all_approval_workflows",
  CAN_MANAGE_ALL_APPROVAL_WORKFLOWS = "can_manage_all_approval_workflows",
  CAN_VIEW_ALL_APPROVAL_REQUESTS = "can_view_all_approval_requests",
  CAN_MANAGE_APPROVAL_REQUESTS = "can_manage_approval_requests",
  CAN_OVERRIDE_APPROVAL_REQUESTS = "can_override_approval_requests",
  CAN_VIEW_ALL_TRAVEL_POLICIES = "can_view_all_travel_policies",
  CAN_MANAGE_ALL_TRAVEL_POLICIES = "can_manage_all_travel_policies",
  CAN_VIEW_ORGANIZATION_SETUP = "can_view_organization_setup",
  CAN_MANAGE_ORGANIZATION_SETUP = "can_manage_organization_setup",
  CAN_VIEW_ALL_TRAVELER_PROFILES = "can_view_all_traveler_profiles",
  CAN_MANAGE_ALL_TRAVELER_PROFILES = "can_manage_all_traveler_profiles",
  CAN_VIEW_OWN_TRAVELER_PROFILE = "can_view_own_traveler_profile",
  CAN_MANAGE_SELF_TRAVELER_PROFILE = "can_manage_self_traveler_profile",
  CAN_CREATE_BOOKING_FOR_ALL = "can_create_booking_for_all",
  CAN_CREATE_SELF_BOOKING_FLIGHTS = "can_create_self_booking_flights",
  CAN_CREATE_GUEST_BOOKING_FLIGHTS = "can_create_guest_booking_flights",
}
